/**
 * A status pill in Monday's own colour.
 *
 * ⚠ The colour comes from the board, on every refresh — `labelColour` reads the palette the
 * API returned with the items. There is no generated copy in this application, which is
 * hard rule 10's failure mode removed rather than managed: recolour a status on the board
 * and the report follows, and nobody can hand-edit a table that will be regenerated.
 *
 * `tint` turns Monday's solid hex into a readable pill — their palette is chosen for a
 * coloured cell on a white board, and #a1e3f6 as text on white is invisible.
 */

import { labelColour, tint, type LabelColours } from "@cocon-stats/shared";

export function MondayPill({
  colours,
  group,
  label,
  title,
  className = "",
}: {
  colours: LabelColours;
  /** A key of the colour map: `status`, `company`, `acceptance`, `iteration`, … */
  group: string;
  label: string | null;
  title?: string;
  className?: string;
}) {
  // An em dash, never "N/A" and never an empty cell — a ticket with no priority set is a
  // real state and should look like one.
  if (!label) return <span className="text-slate-300">—</span>;

  const t = tint(labelColour(colours, group, label));
  return (
    <span
      className={`pill ${className}`}
      style={{ background: t.bg, borderColor: t.border, color: t.text }}
      title={title}
    >
      {label}
    </span>
  );
}

/** The solid colour for a chart slice or a bar. */
export function mondayColour(colours: LabelColours, group: string, label: string): string {
  return labelColour(colours, group, label);
}
